import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      'nav.home': 'Home',
      'nav.about': 'About Us',
      'nav.vision': 'Vision & Mission',
      'nav.products': 'Weapons and Ammunition',
      'nav.contact': 'Contact',
      
      // Language Switcher
      'language.en': 'English',
      'language.fr': 'Français',
      
      // Hero Section
      'hero.title': 'ENGINEERING THE FUTURE OF UNMANNED DEFENSE',
      'hero.subtitle': 'Centron Aerospace',
      'hero.description': 'Centron Aerospace develops advanced unmanned aerial platforms with unmatched precision, speed, and operational readiness — designed and tested by proven experts in defense technology.',
      'hero.cta': 'Learn More',
      
      // About Section
      'about.title': 'About Us',
      'about.mission.title': 'Our Mission',
      'about.mission.text': 'To provide innovative aerospace and defense engineering solutions that ensure national security and advance technological capabilities.',
      'about.vision.title': 'Our Vision',
      'about.vision.text': 'To be the global leader in aerospace engineering, setting new standards for excellence and innovation in defense technology.',
      'about.history.title': 'Our History',
      'about.history.text': 'Founded with a commitment to excellence, Centron Aerospace has been at the forefront of aerospace innovation for over two decades.',
      
      // Quick Overview Section
      'overview.title': 'Quick Overview',
      'overview.proven.title': 'Proven Team',
      'overview.proven.text': 'Designed, tested, and delivered operational UAVs to defense clients worldwide',
      'overview.technology.title': 'Cutting-Edge Technology',
      'overview.technology.text': 'High-performance systems built to meet modern battlefield requirements',
      'overview.mission.title': 'Full Mission Capability',
      'overview.mission.text': 'From concept to deployment, we deliver operational superiority',
      
      // Products Section
      'products.title': 'Our Products',
      'products.subtitle': 'Advanced Aerospace Solutions',
      'products.download': 'Download Brochure',
      
      // Contact Section
      'contact.title': 'Contact Us',
      'contact.subtitle': 'Get in Touch',
      'contact.form.name': 'Full Name',
      'contact.form.email': 'Email Address',
      'contact.form.message': 'Message',
      'contact.form.send': 'Send Message',
      'contact.form.required': 'This field is required',
      'contact.form.emailInvalid': 'Please enter a valid email address',
      'contact.form.success': 'Message sent successfully!',
      'contact.form.error': 'Error sending message. Please try again.',
      'contact.location.title': 'Our Locations',
      'contact.location.address': 'Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E.',
      'contact.location.address.dubai': 'Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E.',
      
      // Footer
      'footer.copyright': '© 2024 Centron Aerospace and Defense LLC. All rights reserved.',
      'footer.privacy': 'Privacy Policy',
      'footer.terms': 'Terms of Service',
      'footer.description': 'Leading provider of advanced aerospace and defense engineering solutions, delivering innovative technology for national security and global advancement.',
      'footer.quickLinks': 'Quick Links',
      'footer.productsServices': 'Products & Services',
      
      // Product Names
      'product.radar.name': 'Advanced Radar Systems',
      'product.radar.description': 'Next-generation radar technology for military and civilian applications.',
      'product.avionics.name': 'Avionics Solutions',
      'product.avionics.description': 'State-of-the-art avionics systems for modern aircraft.',
      'product.satellite.name': 'Satellite Technology',
      'product.satellite.description': 'Cutting-edge satellite systems for communication and surveillance.',
      'product.weapons.name': 'Weapons Systems',
      'product.weapons.description': 'Precision weapons systems for defense applications.',
      
      // Admin Panel
      'admin.title': 'Admin Panel',
      'admin.welcome': 'Welcome',
      'admin.logout': 'Logout',
      'admin.database.title': 'Database Management',
      'admin.sample.title': 'Sample Data',
      'admin.sample.description': 'No sample products available. Add products manually using the form.',
      'admin.sample.button': 'No Sample Data',
      'admin.delete.title': 'Delete All Products',
      'admin.delete.description': 'Permanently delete all products from the database.',
      'admin.delete.button': 'Delete All',
      'admin.stats.title': 'Collection Statistics',
      'admin.stats.description': 'Display statistics for the products collection.',
      'admin.stats.button': 'Get Collection Stats',
      'admin.products.title': 'Product Management',
      'admin.add.title': 'Add New Product',
      'admin.add.cancel': 'Cancel',
      'admin.form.name': 'Product Name',
      'admin.form.category': 'Category',
      'admin.form.imageUrl': 'Image URL',
      'admin.form.specs.title': 'Specifications',
      'admin.form.specs.add': '+ Add Spec',
             'admin.form.specs.name': 'Spec Name (e.g., maxSpeed)',
       'admin.form.specs.value': 'Spec Value (e.g., 450 km/h)',
       'admin.form.description': 'Product Description',
       'admin.form.description.placeholder': 'Enter detailed product description...',
       'admin.form.submit': 'Add Product',
      'admin.form.adding': 'Adding...',
      'admin.products.list': 'Current Products',
      'admin.products.specs': 'specifications',
      'admin.products.delete': 'Delete',
      'admin.products.none': 'No products found',
      'admin.loading': 'Loading...',
      'admin.deleting': 'Deleting...',
      'admin.seeding': 'Seeding...',
      'admin.getting': 'Getting...',
      
      // Image Upload
      'admin.image.dragDrop': 'Drag & drop images here',
      'admin.image.selectFiles': 'Select Files',
      'admin.image.orClick': 'or click to browse',
      'admin.image.supportedFormats': 'PNG, JPG, JPEG, GIF, WebP up to 5MB each',
      'admin.image.maxSize': 'Max 5MB',
      'admin.image.uploading': 'Uploading images...',
      'admin.image.uploadSuccess': 'Images uploaded successfully!',
      'admin.image.uploadError': 'Upload failed',
      'admin.image.invalidType': 'Please select valid image files',
      'admin.image.tooLarge': 'Image size must be less than 5MB',
      'admin.image.clickToChange': 'Click to change image',
      'admin.image.addMore': 'Add More Images',
      'admin.form.images': 'Product Images',
      
      // Admin Login
      'admin.login.title': 'Admin Login',
      'admin.login.subtitle': 'Access Admin Panel',
      'admin.login.email': 'Email Address',
      'admin.login.password': 'Password',
      'admin.login.submit': 'Login',
      'admin.login.loading': 'Logging in...',
      'admin.login.error': 'Login error',
      'admin.login.access.denied': 'Access denied. Admin privileges required.',
      
      // Products Page
      'products.loading': 'Loading products...',
      'products.error': 'Error loading products',
      'products.refresh': '🔄 Refresh Data',
      'products.refreshing': 'Refreshing...',
      'products.browse.title': 'Browse by Category',
      'products.all': 'All Products',
      
      // Messages
      'message.success': 'Operation successful!',
      'message.error': 'Error during operation',
      'message.deleted': 'products deleted successfully!',
      'message.added': 'Product added successfully!',
      'message.deleted.single': 'Product deleted successfully!',
      'message.no.sample': 'No sample products available. Use admin panel to add products manually.',
      
      // About Us Page
      'about.page.title': 'About Us',
      'about.page.main.title': 'ABOUT CENTRON',
      'about.page.defense.title': 'DEFENSE INNOVATION LEADER',
      'about.page.defense.description1': 'Centron Aerospace is a premier defense technology company specializing in advanced unmanned aerial systems, precision-guided munitions, and cutting-edge aerospace engineering solutions.',
      'about.page.defense.description2': 'With over 15 years of experience in military technology development, we deliver innovative solutions that enhance national security and provide tactical advantages to defense forces worldwide.',
      'about.page.feature.technology.title': 'ADVANCED TECHNOLOGY',
      'about.page.feature.technology.description': 'State-of-the-art UAV systems with cutting-edge stealth and precision capabilities.',
      'about.page.feature.mission.title': 'MISSION SUCCESS',
      'about.page.feature.mission.description': 'Proven track record of 100% mission success rate across all operational deployments.',
      'about.page.feature.expert.title': 'EXPERT TEAM',
      'about.page.feature.expert.description': 'Elite engineers and defense specialists with decades of combined experience.',
      'about.company.title': 'Centron Aerospace and Engineering',
      'about.company.description1': 'Centron Aerospace and Engineering (Centron Aero) is a next‑generation defense company focused on developing autonomous, scalable, and mission‑ready unmanned systems. Founded by a team of seasoned defense professionals with over 20 years of experience each, Centron addresses the emerging paradigm of modern warfare where speed, adaptability, and precision have replaced heavy armor and static doctrine as the primary drivers of battlefield superiority.',
      'about.company.description2': 'Our flagship technology is a modular VTOL platform capable of transforming seamlessly between loitering munition, reconnaissance, patrol, and long‑range surveillance roles. This single‑platform approach simplifies logistics and training, while modularity enables custom configurations to meet diverse mission requirements. By eliminating runway dependence and merging vertical lift with fixed‑wing endurance, Centron\'s systems deliver unmatched operational flexibility at lower infrastructure cost.',
      'about.feature.modular.title': 'Modular VTOL Platform',
      'about.feature.modular.description': 'Seamless transformation between multiple mission roles',
      'about.feature.flexibility.title': 'Operational Flexibility',
      'about.feature.flexibility.description': 'Unmatched adaptability at lower infrastructure cost',
      'about.feature.expertise.title': 'Proven Expertise',
      'about.feature.expertise.description': '20+ years of defense industry experience',
      
      // Vision & Mission Page
      'vision.page.title': 'Vision & Mission',
      'vision.page.main.title': 'VISION & MISSION',
      'vision.page.vision.title': 'OUR VISION',
      'vision.page.vision.description1': 'To be the global leader in advanced aerospace defense technology, delivering innovative solutions that redefine the future of military operations and national security.',
      'vision.page.vision.description2': 'We envision a world where cutting-edge technology ensures peace through superior defense capabilities, protecting nations while advancing the frontiers of aerospace engineering.',
      'vision.page.mission.title': 'OUR MISSION',
      'vision.page.mission.description': 'To develop and deliver state-of-the-art unmanned aerial systems, precision-guided munitions, and aerospace engineering solutions that provide tactical superiority and strategic advantage to defense forces worldwide.',
      'vision.page.values.innovation.title': 'INNOVATION',
      'vision.page.values.innovation.description': 'Pushing the boundaries of aerospace technology with cutting-edge research and development.',
      'vision.page.values.excellence.title': 'EXCELLENCE',
      'vision.page.values.excellence.description': 'Maintaining the highest standards of quality and performance in every project we undertake.',
      'vision.page.values.integrity.title': 'INTEGRITY',
      'vision.page.values.integrity.description': 'Operating with unwavering ethical standards and commitment to national security.',
      'vision.page.goals.title': 'STRATEGIC GOALS',
      'vision.page.goals.technology.title': 'TECHNOLOGICAL LEADERSHIP',
      'vision.page.goals.technology.description': 'Establish Centron Aerospace as the premier innovator in UAV technology and aerospace engineering.',
      'vision.page.goals.expansion.title': 'GLOBAL EXPANSION',
      'vision.page.goals.expansion.description': 'Expand our presence to serve defense forces across multiple continents and regions.',
      'vision.page.goals.growth.title': 'SUSTAINABLE GROWTH',
      'vision.page.goals.growth.description': 'Achieve sustainable business growth while maintaining our commitment to quality and innovation.',
      'vision.page.goals.talent.title': 'TALENT DEVELOPMENT',
      'vision.page.goals.talent.description': 'Attract and develop world-class engineering talent to drive our technological advancement.',
      'vision.reality.title': 'The New Reality of Modern Warfare',
      'vision.reality.description1': 'Modern warfare has entered an era of rapid transformation. Traditional weapon systems and countermeasures—built for predictable engagements and slower decision cycles—are no longer sufficient. Superiority on the battlefield is no longer achieved solely through heavier armor or larger firepower, but through speed, intelligence, and adaptability.',
      'vision.reality.description2': 'Conflict today demands solutions that are fast to deploy, resilient to loss, and capable of operating effectively in chaotic, communication‑denied environments.',
      'vision.mission.title': 'Our Mission',
      'vision.mission.description': 'Centron Aerospace and Engineering was created to address this new reality. We are a next‑generation defense technology company developing autonomous, scalable, and effective unmanned systems and payloads that give warfighters the decisive edge. Drawing on deep expertise in AI, military‑grade engineering, and modern operational doctrine, we design and manufacture mission‑ready solutions tailored to the evolving demands of high‑intensity conflict.',
      'vision.technology.title': 'Indigenous Technology Development',
      'vision.technology.description': 'Crucially, all flight control, autonomy, and sensor integration software are developed in-house. These capabilities are fully indigenous, granting Centron complete control over system performance, security, and future upgrades—a decisive advantage in an era where sovereign technology and export resilience are critical to mission success.',
      'vision.principle.speed.title': 'Speed & Agility',
      'vision.principle.speed.description': 'Fast deployment and rapid response capabilities for dynamic battlefield conditions',
      'vision.principle.intelligence.title': 'Intelligence & Autonomy',
      'vision.principle.intelligence.description': 'Advanced AI-driven systems for intelligent decision-making in complex environments',
      'vision.principle.resilience.title': 'Resilience & Adaptability',
      'vision.principle.resilience.description': 'Robust systems capable of operating in communication-denied environments',
      
      // Home Page
      'home.title': 'CENTRON',
      'home.subtitle': 'AEROSPACE',
      'home.tagline': 'DEFENSE & ENGINEERING',
      'home.description': 'Advanced tactical UAV systems, cruise missile technology, and cutting-edge aerospace engineering solutions for national defense and global security.',
      'home.uavPlatform': 'UAV PLATFORM',
      'home.rdProjects': 'R&D PROJECTS',
      'home.scroll': 'SCROLL',
      'home.militaryCapabilities': 'MILITARY CAPABILITIES',
      'home.advancedTacticalUAV': 'ADVANCED TACTICAL UAV',
      'home.advancedTacticalUAVDesc': 'High-performance unmanned aerial vehicles designed for reconnaissance, surveillance, and tactical operations. Featuring advanced stealth technology and extended range capabilities.',
      'home.stealthTechnology': 'STEALTH TECHNOLOGY',
      'home.stealthTechnologyDesc': 'Advanced radar-absorbing materials and aerodynamic design for maximum operational security.',
      'home.cruiseMissileSystems': 'CRUISE MISSILE SYSTEMS',
      'home.cruiseMissileSystemsDesc': 'Precision-guided missile technology with advanced targeting and navigation systems.',
      'home.fullMissionCapability': 'FULL MISSION CAPABILITY',
      'home.fullMissionCapabilityDesc': 'From concept to deployment, we provide complete mission solutions with cutting-edge technology and proven expertise in defense systems engineering.',
      'home.aerospaceTechnology': 'AEROSPACE TECHNOLOGY',
      'home.uavFighter': 'UAV FIGHTER',
      'home.uavFighterDesc': 'Advanced combat UAV with air-to-air and air-to-ground capabilities',
      'home.intelligentCruiseMissile': 'INTELLIGENT CRUISE MISSILE',
      'home.intelligentCruiseMissileDesc': 'AI-powered precision strike systems with autonomous navigation',
      'home.tacticalPlatforms': 'TACTICAL PLATFORMS',
      'home.tacticalPlatformsDesc': 'Multi-role UAV platforms for various military applications',
      'home.yearsExperience': 'YEARS EXPERIENCE',
      'home.militaryProjects': 'MILITARY PROJECTS',
      'home.missionSuccess': 'MISSION SUCCESS',
      'home.supportAvailable': 'SUPPORT AVAILABLE',
      'home.defenseReady': 'DEFENSE READY?',
      'home.defenseReadyDesc': 'Let\'s discuss your defense requirements and explore how Centron Aerospace can deliver exceptional military-grade solutions.',
             'home.contactUs': 'CONTACT US',
       'home.viewPlatforms': 'VIEW PLATFORMS',
       
       // UAV Platform Page
       'uav.page.title': 'UAV PLATFORM',
       'uav.product.name': 'Advanced Tactical UAV Platform',
       'uav.product.tagline': 'Power in the Sky',
       'uav.product.description': 'High-performance tactical UAV designed for precision operations and extended mission capabilities with advanced stealth technology and military-grade security.',
       'uav.specs.title': 'TECHNICAL SPECIFICATIONS',
       'uav.specs.subtitle': 'Comprehensive technical specifications designed for maximum operational efficiency and mission success.',
       'uav.specs.flightDuration': 'Maximum Flight Duration',
       'uav.specs.payloadCapacity': 'Payload Capacity',
       'uav.specs.motorType': 'Motor Type',
       'uav.specs.wingspan': 'Wingspan',
       'uav.specs.bodyStructure': 'Body Structure',
       'uav.specs.verticalTakeoff': 'Vertical Takeoff',
       'uav.specs.maxFlightRange': 'Maximum Flight Range',
       'uav.specs.maxLinkDistance': 'Maximum Link Distance',
       'uav.specs.maxFlightSpeed': 'Maximum Flight Speed',
       'uav.applications.title': 'APPLICATION AREAS',
       'uav.applications.subtitle': 'Versatile platform designed for multiple operational scenarios and mission requirements.',
       'uav.applications.military.title': 'Military Operations',
       'uav.applications.military.description': 'Tactical reconnaissance, surveillance, and precision strike capabilities for modern warfare.',
       'uav.applications.intelligence.title': 'Intelligence Gathering',
       'uav.applications.intelligence.description': 'Advanced sensor systems for comprehensive intelligence and surveillance operations.',
       'uav.applications.border.title': 'Border Security',
       'uav.applications.border.description': 'Long-range surveillance and monitoring for border protection and security operations.',
       'uav.applications.emergency.title': 'Emergency Response',
       'uav.applications.emergency.description': 'Rapid deployment capabilities for emergency situations and disaster response.',
       'uav.cta.title': 'MISSION READY',
       'uav.cta.description': 'Contact our tactical UAV specialists to discuss your operational requirements and mission specifications.',
       'uav.cta.contact': 'Contact UAV Team',
       'uav.cta.quote': 'Request Quote',
       
       // R&D Page
       'rd.page.title': 'RESEARCH & DEVELOPMENT',
       'rd.products.title': 'ADVANCED R&D PRODUCTS',
       'rd.products.subtitle': 'Cutting-edge technologies developed through our extensive research and development programs.',
       'rd.specs.title': 'TECHNICAL SPECIFICATIONS',
       'rd.innovation.title': 'INNOVATION HIGHLIGHTS',
       'rd.innovation.subtitle': 'Revolutionary breakthroughs that define the future of aerospace defense technology.',
       'rd.innovation.ai.title': 'AI INTEGRATION',
       'rd.innovation.ai.description': 'Advanced artificial intelligence systems for autonomous decision-making and mission optimization.',
       'rd.innovation.stealth.title': 'STEALTH TECHNOLOGY',
       'rd.innovation.stealth.description': 'Next-generation stealth materials and design principles for maximum operational survivability.',
       'rd.innovation.propulsion.title': 'ADVANCED PROPULSION',
       'rd.innovation.propulsion.description': 'Revolutionary propulsion systems achieving unprecedented performance and efficiency.',
               'rd.cta.title': 'READY TO INNOVATE',
        'rd.cta.description': 'Partner with our R&D team to develop the next generation of aerospace defense technologies.',
        'rd.cta.contact': 'Contact R&D Team',
        'rd.cta.partnerships': 'Explore Partnerships',
        
        // R&D Innovation Highlights Section
        'rd.innovation.title': 'INNOVATION HIGHLIGHTS',
        'rd.innovation.subtitle': 'Revolutionary breakthroughs that define the future of aerospace defense technology.',
        'rd.innovation.ai.title': 'AI INTEGRATION',
        'rd.innovation.ai.description': 'Advanced artificial intelligence systems for autonomous decision-making and mission optimization.',
        'rd.innovation.stealth.title': 'STEALTH TECHNOLOGY',
        'rd.innovation.stealth.description': 'Next-generation stealth materials and design principles for maximum operational survivability.',
        'rd.innovation.propulsion.title': 'ADVANCED PROPULSION',
        'rd.innovation.propulsion.description': 'Revolutionary propulsion systems achieving unprecedented performance and efficiency.',
        
        // R&D Products
       'rd.product.uavFighter.name': 'UAV Fighter',
       'rd.product.uavFighter.tagline': 'Next-Generation Combat Drone',
       'rd.product.uavFighter.description': 'Advanced unmanned combat aerial vehicle designed for superior air superiority and precision strike capabilities with cutting-edge stealth technology and AI-powered mission systems.',
       'rd.product.uavFighter.features.1': 'Advanced AI-powered autonomous operations',
       'rd.product.uavFighter.features.2': 'Multi-spectral stealth technology',
       'rd.product.uavFighter.features.3': 'Supersonic cruise capability',
       'rd.product.uavFighter.features.4': 'Network-centric warfare integration',
       
       'rd.product.cruiseMissile.name': 'Mini Intelligent Cruise Missile',
       'rd.product.cruiseMissile.tagline': 'Precision Strike Technology',
       'rd.product.cruiseMissile.description': 'Revolutionary miniaturized cruise missile system featuring advanced guidance, extended range, and precision targeting capabilities for tactical and strategic operations.',
       'rd.product.cruiseMissile.features.1': 'Advanced terrain-following navigation',
       'rd.product.cruiseMissile.features.2': 'Multi-target engagement capability',
       'rd.product.cruiseMissile.features.3': 'Real-time mission re-tasking',
       'rd.product.cruiseMissile.features.4': 'Enhanced survivability features',
       
       // Weapons & Ammunition Page
       'weapons.page.title': 'WEAPONS & AMMUNITION',
       'weapons.page.subtitle': 'Advanced defense systems and precision munitions',
       'weapons.sections.weapons.title': 'WEAPONS',
       'weapons.sections.ammunition.title': 'AMMUNITION',
       'weapons.browse.title': 'Browse by Category',
       'weapons.noWeapons': 'NO WEAPONS FOUND',
       'weapons.noAmmunition': 'NO AMMUNITION FOUND',
       'weapons.loading': 'Loading products...',
       'weapons.error': 'Error loading products',
       'weapons.refresh': '🔄 Refresh Data',
       'weapons.refreshing': 'Refreshing...',
       'weapons.modal.close': 'Close',
       'weapons.modal.specs': 'Specifications',
       
       // Weapons & Ammunition Technology Section
       'weapons.technology.title': 'ADVANCED TECHNOLOGY',
       'weapons.technology.subtitle': 'Our products incorporate cutting-edge technology developed through decades of research and real-world application.',
       'weapons.technology.ai.title': 'AI INTEGRATION',
       'weapons.technology.ai.description': 'Machine learning algorithms for predictive maintenance and intelligent threat detection.',
       'weapons.technology.cybersecurity.title': 'CYBERSECURITY',
       'weapons.technology.cybersecurity.description': 'Military-grade encryption and secure communication protocols for all systems.',
       'weapons.technology.performance.title': 'PERFORMANCE',
       'weapons.technology.performance.description': 'Optimized for maximum efficiency and reliability in extreme conditions.',
       
       // Weapons & Ammunition CTA Section
       'weapons.cta.title': 'NEED CUSTOM SOLUTIONS?',
       'weapons.cta.subtitle': 'Our engineering team specializes in developing tailored solutions for unique requirements.',
       'weapons.cta.button': 'Contact Our Engineers',
       
       // Contact Page
       'contact.page.title': 'CONTACT US',
       'contact.page.subtitle': 'Get in Touch',
       'contact.form.title': 'SEND MESSAGE',
       'contact.form.name': 'Full Name',
       'contact.form.email': 'Email Address',
       'contact.form.message': 'Message',
       'contact.form.submit': 'Send Message',
       'contact.form.sending': 'Sending...',
       'contact.form.success': 'Message sent successfully!',
       'contact.form.error': 'Failed to send message. Please try again or contact us directly.',
       'contact.company.title': 'COMPANY INFO',
       'contact.company.email.title': 'EMAIL',
       'contact.company.email.value': 'sales@centronaero.com',
       'contact.company.linkedin.title': 'LINKEDIN',
       'contact.company.linkedin.value': 'Centron Aerospace & Engineering'
    }
  },

  fr: {
    translation: {
      // Navigation
      'nav.home': 'Accueil',
      'nav.about': 'À Propos',
      'nav.vision': 'Vision & Mission',
      'nav.products': 'Armes et Munitions',
      'nav.contact': 'Contact',
      
      // Hero Section
      'hero.title': 'CONCEPTION DE L\'AVENIR DE LA DÉFENSE SANS PILOTE',
      'hero.subtitle': 'Centron Aerospace',
      'hero.description': 'Centron Aerospace développe des plateformes aériennes sans pilote avancées avec une précision, une vitesse et une disponibilité opérationnelle inégalées — conçues et testées par des experts éprouvés en technologie de défense.',
      'hero.cta': 'En Savoir Plus',
      
      // About Section
      'about.title': 'À Propos de Nous',
      'about.mission.title': 'Notre Mission',
      'about.mission.text': 'Fournir des solutions d\'ingénierie aérospatiale et de défense innovantes qui assurent la sécurité nationale et développent les capacités technologiques.',
      'about.vision.title': 'Notre Vision',
      'about.vision.text': 'Être le leader mondial en ingénierie aérospatiale, établissant de nouveaux standards d\'excellence et d\'innovation en technologie de défense.',
      'about.history.title': 'Notre Histoire',
      'about.history.text': 'Fondée avec un engagement envers l\'excellence, Centron Aerospace est à l\'avant-garde de l\'innovation aérospatiale depuis plus de deux décennies.',
      
      // Quick Overview Section
      'overview.title': 'Aperçu Rapide',
      'overview.proven.title': 'Équipe Éprouvée',
      'overview.proven.text': 'Conçu, testé et livré des UAV opérationnels à des clients de défense dans le monde entier',
      'overview.technology.title': 'Technologie de Pointe',
      'overview.technology.text': 'Systèmes haute performance conçus pour répondre aux exigences du champ de bataille moderne',
      'overview.mission.title': 'Capacité de Mission Complète',
      'overview.mission.text': 'Du concept au déploiement, nous livrons la supériorité opérationnelle',
      
      // Products Section
      'products.title': 'Nos Produits',
      'products.subtitle': 'Solutions Aérospatiales Avancées',
      'products.download': 'Télécharger la Brochure',
      
      // Contact Section
      'contact.title': 'Contactez-Nous',
      'contact.subtitle': 'Entrez en Contact',
      'contact.form.name': 'Nom Complet',
      'contact.form.email': 'Adresse Email',
      'contact.form.message': 'Message',
      'contact.form.send': 'Envoyer le Message',
      'contact.form.required': 'Ce champ est requis',
      'contact.form.emailInvalid': 'Veuillez entrer une adresse email valide',
      'contact.form.success': 'Message envoyé avec succès !',
      'contact.form.error': 'Erreur lors de l\'envoi du message. Veuillez réessayer.',
      'contact.location.title': 'Nos Localisations',
      'contact.location.address': 'Meydan Grandstand, 6ème étage, Meydan Road, Nad Al Sheba, Dubaï, E.A.U.',
      'contact.location.address.dubai': 'Meydan Grandstand, 6ème étage, Meydan Road, Nad Al Sheba, Dubaï, E.A.U.',
      
      // Footer
      'footer.copyright': '© 2024 Centron Aerospace et Defense LLC. Tous droits réservés.',
      'footer.privacy': 'Politique de Confidentialité',
      'footer.terms': 'Conditions de Service',
      'footer.description': 'Fournisseur leader de solutions d\'ingénierie aérospatiale et de défense avancées, fournissant une technologie innovante pour la sécurité nationale et l\'avancement mondial.',
      'footer.quickLinks': 'Liens Rapides',
      'footer.productsServices': 'Produits & Services',
      
      // Product Names
      'product.radar.name': 'Systèmes Radar Avancés',
      'product.radar.description': 'Technologie radar de nouvelle génération pour applications militaires et civiles.',
      'product.avionics.name': 'Solutions Avioniques',
      'product.avionics.description': 'Systèmes avioniques de pointe pour aéronefs modernes.',
      'product.satellite.name': 'Technologie Satellite',
      'product.satellite.description': 'Systèmes satellite de pointe pour communication et surveillance.',
      'product.weapons.name': 'Systèmes d\'Armement',
      'product.weapons.description': 'Systèmes d\'armement de précision pour applications de défense.',
      
      // Admin Panel
      'admin.title': 'Panneau d\'Administration',
      'admin.welcome': 'Bienvenue',
      'admin.logout': 'Déconnexion',
      'admin.database.title': 'Gestion de Base de Données',
      'admin.sample.title': 'Données d\'Exemple',
      'admin.sample.description': 'Aucun produit d\'exemple disponible. Ajoutez des produits manuellement via le formulaire.',
      'admin.sample.button': 'Aucune Donnée d\'Exemple',
      'admin.delete.title': 'Supprimer Tous les Produits',
      'admin.delete.description': 'Supprime définitivement tous les produits de la base de données.',
      'admin.delete.button': 'Supprimer Tout',
      'admin.stats.title': 'Statistiques de Collection',
      'admin.stats.description': 'Affiche les statistiques de la collection de produits.',
      'admin.stats.button': 'Obtenir les Statistiques',
      'admin.products.title': 'Gestion des Produits',
      'admin.add.title': 'Ajouter un Nouveau Produit',
      'admin.add.cancel': 'Annuler',
      'admin.form.name': 'Nom du Produit',
      'admin.form.category': 'Catégorie',
      'admin.form.imageUrl': 'URL de l\'Image',
      'admin.form.specs.title': 'Spécifications',
      'admin.form.specs.add': '+ Ajouter une Spec',
             'admin.form.specs.name': 'Nom de la Spec (ex: maxSpeed)',
       'admin.form.specs.value': 'Valeur de la Spec (ex: 450 km/h)',
       'admin.form.description': 'Description du Produit',
       'admin.form.description.placeholder': 'Entrez la description détaillée du produit...',
       'admin.form.submit': 'Ajouter le Produit',
      'admin.form.adding': 'Ajout en cours...',
      'admin.products.list': 'Produits Actuels',
      'admin.products.specs': 'spécifications',
      'admin.products.delete': 'Supprimer',
      'admin.products.none': 'Aucun produit trouvé',
      'admin.loading': 'Chargement...',
      'admin.deleting': 'Suppression...',
      'admin.seeding': 'Ajout en cours...',
      'admin.getting': 'Obtention...',
      
      // Image Upload
      'admin.image.dragDrop': 'Glissez-déposez des images ici',
      'admin.image.selectFiles': 'Sélectionner des Fichiers',
      'admin.image.orClick': 'ou cliquez pour parcourir',
      'admin.image.supportedFormats': 'PNG, JPG, JPEG, GIF, WebP jusqu\'à 5MB chacun',
      'admin.image.maxSize': 'Max 5MB',
      'admin.image.uploading': 'Téléchargement des images...',
      'admin.image.uploadSuccess': 'Images téléchargées avec succès !',
      'admin.image.uploadError': 'Échec du téléchargement',
      'admin.image.invalidType': 'Veuillez sélectionner des fichiers image valides',
      'admin.image.tooLarge': 'La taille de l\'image doit être inférieure à 5MB',
      'admin.image.clickToChange': 'Cliquez pour changer l\'image',
      'admin.image.addMore': 'Ajouter Plus d\'Images',
      'admin.form.images': 'Images du Produit',
      
      // Admin Login
      'admin.login.title': 'Connexion Administrateur',
      'admin.login.subtitle': 'Accès au Panneau d\'Administration',
      'admin.login.email': 'Adresse Email',
      'admin.login.password': 'Mot de Passe',
      'admin.login.submit': 'Se Connecter',
      'admin.login.loading': 'Connexion...',
      'admin.login.error': 'Erreur de connexion',
      'admin.login.access.denied': 'Accès refusé. Privilèges d\'administrateur requis.',
      
      // Products Page
      'products.loading': 'Chargement des produits...',
      'products.error': 'Erreur de chargement des produits',
      'products.refresh': '🔄 Actualiser les Données',
      'products.refreshing': 'Actualisation...',
      'products.browse.title': 'Parcourir par Catégorie',
      'products.all': 'Tous les Produits',
      
      // Messages
      'message.success': 'Opération réussie !',
      'message.error': 'Erreur lors de l\'opération',
      'message.deleted': 'produits supprimés avec succès !',
      'message.added': 'Produit ajouté avec succès !',
      'message.deleted.single': 'Produit supprimé avec succès !',
      'message.no.sample': 'Aucun produit d\'exemple disponible. Utilisez le panneau d\'administration pour ajouter des produits manuellement.',
      
      // About Us Page
      'about.page.title': 'À Propos de Nous',
      'about.page.main.title': 'À PROPOS DE CENTRON',
      'about.page.defense.title': 'LEADER DE L\'INNOVATION EN DÉFENSE',
      'about.page.defense.description1': 'Centron Aerospace est une entreprise de technologie de défense de premier plan spécialisée dans les systèmes aériens sans pilote avancés, les munitions guidées de précision et les solutions d\'ingénierie aérospatiale de pointe.',
      'about.page.defense.description2': 'Avec plus de 15 ans d\'expérience dans le développement de technologies militaires, nous fournissons des solutions innovantes qui améliorent la sécurité nationale et offrent des avantages tactiques aux forces de défense du monde entier.',
      'about.page.feature.technology.title': 'TECHNOLOGIE AVANCÉE',
      'about.page.feature.technology.description': 'Systèmes d\'UAV de pointe avec des capacités furtives et de précision de pointe.',
      'about.page.feature.mission.title': 'SUCCÈS DE MISSION',
      'about.page.feature.mission.description': 'Antécédents prouvés de 100% de taux de succès de mission dans tous les déploiements opérationnels.',
      'about.page.feature.expert.title': 'ÉQUIPE D\'EXPERTS',
      'about.page.feature.expert.description': 'Ingénieurs d\'élite et spécialistes de la défense avec des décennies d\'expérience combinée.',
      'about.company.title': 'Centron Aerospace et Ingénierie',
      'about.company.description1': 'Centron Aerospace et Ingénierie (Centron Aero) est une entreprise de défense de nouvelle génération axée sur le développement de systèmes sans pilote autonomes, évolutifs et prêts pour mission. Fondée par une équipe de professionnels de la défense expérimentés avec plus de 20 ans d\'expérience chacun, Centron répond au nouveau paradigme de la guerre moderne où la vitesse, l\'adaptabilité et la précision ont remplacé l\'armure lourde et la doctrine statique comme principaux moteurs de la supériorité sur le champ de bataille.',
      'about.company.description2': 'Notre technologie phare est une plateforme VTOL modulaire capable de se transformer de manière transparente entre les rôles de munition d\'attente, de reconnaissance, de patrouille et de surveillance à longue portée. Cette approche à plateforme unique simplifie la logistique et la formation, tandis que la modularité permet des configurations personnalisées pour répondre aux exigences de mission diverses. En éliminant la dépendance aux pistes et en fusionnant l\'élévation verticale avec l\'endurance à voilure fixe, les systèmes de Centron offrent une flexibilité opérationnelle inégalée à un coût d\'infrastructure inférieur.',
      'about.feature.modular.title': 'Plateforme VTOL Modulaire',
      'about.feature.modular.description': 'Transformation transparente entre plusieurs rôles de mission',
      'about.feature.flexibility.title': 'Flexibilité Opérationnelle',
      'about.feature.flexibility.description': 'Adaptabilité inégalée à un coût d\'infrastructure inférieur',
      'about.feature.expertise.title': 'Expertise Éprouvée',
      'about.feature.expertise.description': 'Plus de 20 ans d\'expérience dans l\'industrie de la défense',
      
      // Vision & Mission Page
      'vision.page.title': 'Vision & Mission',
      'vision.page.main.title': 'VISION & MISSION',
      'vision.page.vision.title': 'NOTRE VISION',
      'vision.page.vision.description1': 'Être le leader mondial en technologie de défense aérospatiale avancée, fournissant des solutions innovantes qui redéfinissent l\'avenir des opérations militaires et de la sécurité nationale.',
      'vision.page.vision.description2': 'Nous envisageons un monde où la technologie de pointe assure la paix grâce à des capacités de défense supérieures, protégeant les nations tout en repoussant les frontières de l\'ingénierie aérospatiale.',
      'vision.page.mission.title': 'NOTRE MISSION',
      'vision.page.mission.description': 'Développer et fournir des systèmes aériens sans pilote de pointe, des munitions guidées de précision et des solutions d\'ingénierie aérospatiale qui offrent une supériorité tactique et un avantage stratégique aux forces de défense du monde entier.',
      'vision.page.values.innovation.title': 'INNOVATION',
      'vision.page.values.innovation.description': 'Repousser les limites de la technologie aérospatiale avec la recherche et le développement de pointe.',
      'vision.page.values.excellence.title': 'EXCELLENCE',
      'vision.page.values.excellence.description': 'Maintenir les plus hauts standards de qualité et de performance dans chaque projet que nous entreprenons.',
      'vision.page.values.integrity.title': 'INTÉGRITÉ',
      'vision.page.values.integrity.description': 'Opérer avec des standards éthiques inébranlables et un engagement envers la sécurité nationale.',
      'vision.page.goals.title': 'OBJECTIFS STRATÉGIQUES',
      'vision.page.goals.technology.title': 'LEADERSHIP TECHNOLOGIQUE',
      'vision.page.goals.technology.description': 'Établir Centron Aerospace comme l\'innovateur de premier plan en technologie UAV et ingénierie aérospatiale.',
      'vision.page.goals.expansion.title': 'EXPANSION MONDIALE',
      'vision.page.goals.expansion.description': 'Étendre notre présence pour servir les forces de défense à travers plusieurs continents et régions.',
      'vision.page.goals.growth.title': 'CROISSANCE DURABLE',
      'vision.page.goals.growth.description': 'Atteindre une croissance commerciale durable tout en maintenant notre engagement envers la qualité et l\'innovation.',
      'vision.page.goals.talent.title': 'DÉVELOPPEMENT DES TALENTS',
      'vision.page.goals.talent.description': 'Attirer et développer des talents d\'ingénierie de classe mondiale pour stimuler notre avancement technologique.',
      'vision.reality.title': 'La Nouvelle Réalité de la Guerre Moderne',
      'vision.reality.description1': 'La guerre moderne est entrée dans une ère de transformation rapide. Les systèmes d\'armes traditionnels et les contre-mesures—construits pour des engagements prévisibles et des cycles de décision plus lents—ne sont plus suffisants. La supériorité sur le champ de bataille n\'est plus obtenue uniquement par une armure plus lourde ou une puissance de feu plus importante, mais par la vitesse, l\'intelligence et l\'adaptabilité.',
      'vision.reality.description2': 'Les conflits d\'aujourd\'hui exigent des solutions qui sont rapides à déployer, résistantes aux pertes et capables d\'opérer efficacement dans des environnements chaotiques et privés de communication.',
      'vision.mission.title': 'Notre Mission',
      'vision.mission.description': 'Centron Aerospace et Ingénierie a été créé pour répondre à cette nouvelle réalité. Nous sommes une entreprise de technologie de défense de nouvelle génération développant des systèmes et charges utiles sans pilote autonomes, évolutifs et efficaces qui donnent aux combattants l\'avantage décisif. S\'appuyant sur une expertise approfondie en IA, en ingénierie de qualité militaire et en doctrine opérationnelle moderne, nous concevons et fabriquons des solutions prêtes pour mission adaptées aux exigences évolutives des conflits de haute intensité.',
      'vision.technology.title': 'Développement Technologique Indigène',
      'vision.technology.description': 'Crucialement, tous les logiciels de contrôle de vol, d\'autonomie et d\'intégration de capteurs sont développés en interne. Ces capacités sont entièrement indigènes, accordant à Centron un contrôle total sur les performances du système, la sécurité et les mises à niveau futures—un avantage décisif dans une ère où la technologie souveraine et la résilience à l\'exportation sont critiques pour le succès de la mission.',
      'vision.principle.speed.title': 'Vitesse & Agilité',
      'vision.principle.speed.description': 'Capacités de déploiement rapide et de réponse rapide pour les conditions de champ de bataille dynamiques',
      'vision.principle.intelligence.title': 'Intelligence & Autonomie',
      'vision.principle.intelligence.description': 'Systèmes avancés pilotés par IA pour la prise de décision intelligente dans des environnements complexes',
      'vision.principle.resilience.title': 'Résilience & Adaptabilité',
      'vision.principle.resilience.description': 'Systèmes robustes capables d\'opérer dans des environnements privés de communication',
      
      // Home Page
      'home.title': 'CENTRON',
      'home.subtitle': 'AÉROSPATIAL',
      'home.tagline': 'DÉFENSE & INGÉNIERIE',
      'home.description': 'Systèmes d\'UAV tactiques avancés, technologie de missiles de croisière et solutions d\'ingénierie aérospatiale de pointe pour la défense nationale et la sécurité mondiale.',
      'home.uavPlatform': 'PLATEFORME UAV',
      'home.rdProjects': 'PROJETS R&D',
      'home.scroll': 'DÉFILER',
      'home.militaryCapabilities': 'CAPACITÉS MILITAIRES',
      'home.advancedTacticalUAV': 'UAV TACTIQUE AVANCÉ',
      'home.advancedTacticalUAVDesc': 'Véhicules aériens sans pilote haute performance conçus pour la reconnaissance, la surveillance et les opérations tactiques. Dotés d\'une technologie furtive avancée et de capacités de portée étendue.',
      'home.stealthTechnology': 'TECHNOLOGIE FURTIVE',
      'home.stealthTechnologyDesc': 'Matériaux absorbant les radars avancés et conception aérodynamique pour une sécurité opérationnelle maximale.',
      'home.cruiseMissileSystems': 'SYSTÈMES DE MISSILES DE CROISIÈRE',
      'home.cruiseMissileSystemsDesc': 'Technologie de missiles guidés de précision avec systèmes de ciblage et de navigation avancés.',
      'home.fullMissionCapability': 'CAPACITÉ DE MISSION COMPLÈTE',
      'home.fullMissionCapabilityDesc': 'Du concept au déploiement, nous fournissons des solutions de mission complètes avec une technologie de pointe et une expertise éprouvée en ingénierie des systèmes de défense.',
      'home.aerospaceTechnology': 'TECHNOLOGIE AÉROSPATIALE',
      'home.uavFighter': 'UAV DE COMBAT',
      'home.uavFighterDesc': 'UAV de combat avancé avec capacités air-air et air-sol',
      'home.intelligentCruiseMissile': 'MISSILE DE CROISIÈRE INTELLIGENT',
      'home.intelligentCruiseMissileDesc': 'Systèmes de frappe de précision alimentés par l\'IA avec navigation autonome',
      'home.tacticalPlatforms': 'PLATEFORMES TACTIQUES',
      'home.tacticalPlatformsDesc': 'Plateformes UAV multi-rôles pour diverses applications militaires',
      'home.yearsExperience': 'ANNÉES D\'EXPÉRIENCE',
      'home.militaryProjects': 'PROJETS MILITAIRES',
      'home.missionSuccess': 'SUCCÈS DE MISSION',
      'home.supportAvailable': 'SUPPORT DISPONIBLE',
      'home.defenseReady': 'PRÊT POUR LA DÉFENSE ?',
      'home.defenseReadyDesc': 'Discutons de vos exigences de défense et explorons comment Centron Aerospace peut fournir des solutions de qualité militaire exceptionnelles.',
             'home.contactUs': 'CONTACTEZ-NOUS',
       'home.viewPlatforms': 'VOIR LES PLATEFORMES',
       
       // UAV Platform Page
       'uav.page.title': 'PLATEFORME UAV',
       'uav.product.name': 'Plateforme UAV Tactique Avancée',
       'uav.product.tagline': 'Puissance dans le Ciel',
       'uav.product.description': 'UAV tactique haute performance conçu pour les opérations de précision et les capacités de mission étendues avec une technologie furtive avancée et une sécurité de qualité militaire.',
       'uav.specs.title': 'SPÉCIFICATIONS TECHNIQUES',
       'uav.specs.subtitle': 'Spécifications techniques complètes conçues pour une efficacité opérationnelle maximale et le succès de mission.',
       'uav.specs.flightDuration': 'Durée de Vol Maximale',
       'uav.specs.payloadCapacity': 'Capacité de Charge Utile',
       'uav.specs.motorType': 'Type de Moteur',
       'uav.specs.wingspan': 'Envergure',
       'uav.specs.bodyStructure': 'Structure du Corps',
       'uav.specs.verticalTakeoff': 'Décollage Vertical',
       'uav.specs.maxFlightRange': 'Portée de Vol Maximale',
       'uav.specs.maxLinkDistance': 'Distance de Liaison Maximale',
       'uav.specs.maxFlightSpeed': 'Vitesse de Vol Maximale',
       'uav.applications.title': 'DOMAINES D\'APPLICATION',
       'uav.applications.subtitle': 'Plateforme polyvalente conçue pour de multiples scénarios opérationnels et exigences de mission.',
       'uav.applications.military.title': 'Opérations Militaires',
       'uav.applications.military.description': 'Capacités de reconnaissance tactique, de surveillance et de frappe de précision pour la guerre moderne.',
       'uav.applications.intelligence.title': 'Collecte de Renseignements',
       'uav.applications.intelligence.description': 'Systèmes de capteurs avancés pour des opérations complètes de renseignement et de surveillance.',
       'uav.applications.border.title': 'Sécurité Frontalière',
       'uav.applications.border.description': 'Surveillance à longue portée et monitoring pour la protection des frontières et les opérations de sécurité.',
       'uav.applications.emergency.title': 'Réponse d\'Urgence',
       'uav.applications.emergency.description': 'Capacités de déploiement rapide pour les situations d\'urgence et la réponse aux catastrophes.',
       'uav.cta.title': 'PRÊT POUR MISSION',
       'uav.cta.description': 'Contactez nos spécialistes UAV tactiques pour discuter de vos exigences opérationnelles et spécifications de mission.',
       'uav.cta.contact': 'Contacter l\'Équipe UAV',
       'uav.cta.quote': 'Demander un Devis',
       
       // R&D Page
       'rd.page.title': 'RECHERCHE ET DÉVELOPPEMENT',
       'rd.products.title': 'PRODUITS R&D AVANCÉS',
       'rd.products.subtitle': 'Technologies de pointe développées grâce à nos programmes de recherche et développement approfondis.',
       'rd.specs.title': 'SPÉCIFICATIONS TECHNIQUES',
       'rd.innovation.title': 'POINTS FORTS DE L\'INNOVATION',
       'rd.innovation.subtitle': 'Percées révolutionnaires qui définissent l\'avenir de la technologie de défense aérospatiale.',
       'rd.innovation.ai.title': 'INTÉGRATION IA',
       'rd.innovation.ai.description': 'Systèmes d\'intelligence artificielle avancés pour la prise de décision autonome et l\'optimisation des missions.',
       'rd.innovation.stealth.title': 'TECHNOLOGIE FURTIVE',
       'rd.innovation.stealth.description': 'Matériaux furtifs et principes de conception de nouvelle génération pour une survie opérationnelle maximale.',
       'rd.innovation.propulsion.title': 'PROPULSION AVANCÉE',
       'rd.innovation.propulsion.description': 'Systèmes de propulsion révolutionnaires atteignant des performances et une efficacité sans précédent.',
               'rd.cta.title': 'PRÊT À INNOVER',
        'rd.cta.description': 'Partenairez avec notre équipe R&D pour développer la prochaine génération de technologies de défense aérospatiale.',
        'rd.cta.contact': 'Contacter l\'Équipe R&D',
        'rd.cta.partnerships': 'Explorer les Partenariats',
        
        // R&D Innovation Highlights Section
        'rd.innovation.title': 'POINTS FORTS DE L\'INNOVATION',
        'rd.innovation.subtitle': 'Percées révolutionnaires qui définissent l\'avenir de la technologie de défense aérospatiale.',
        'rd.innovation.ai.title': 'INTÉGRATION IA',
        'rd.innovation.ai.description': 'Systèmes d\'intelligence artificielle avancés pour la prise de décision autonome et l\'optimisation des missions.',
        'rd.innovation.stealth.title': 'TECHNOLOGIE FURTIVE',
        'rd.innovation.stealth.description': 'Matériaux furtifs et principes de conception de nouvelle génération pour une survie opérationnelle maximale.',
        'rd.innovation.propulsion.title': 'PROPULSION AVANCÉE',
        'rd.innovation.propulsion.description': 'Systèmes de propulsion révolutionnaires atteignant des performances et une efficacité sans précédent.',
        
        // R&D Products
       'rd.product.uavFighter.name': 'UAV de Combat',
       'rd.product.uavFighter.tagline': 'Drone de Combat de Nouvelle Génération',
       'rd.product.uavFighter.description': 'Véhicule aérien de combat sans pilote avancé conçu pour une supériorité aérienne supérieure et des capacités de frappe de précision avec une technologie furtive de pointe et des systèmes de mission alimentés par l\'IA.',
       'rd.product.uavFighter.features.1': 'Opérations autonomes avancées alimentées par l\'IA',
       'rd.product.uavFighter.features.2': 'Technologie furtive multi-spectrale',
       'rd.product.uavFighter.features.3': 'Capacité de croisière supersonique',
       'rd.product.uavFighter.features.4': 'Intégration de guerre centrée sur le réseau',
       
       'rd.product.cruiseMissile.name': 'Missile de Croisière Mini Intelligent',
       'rd.product.cruiseMissile.tagline': 'Technologie de Frappe de Précision',
       'rd.product.cruiseMissile.description': 'Système de missile de croisière miniaturisé révolutionnaire avec guidage avancé, portée étendue et capacités de ciblage de précision pour les opérations tactiques et stratégiques.',
       'rd.product.cruiseMissile.features.1': 'Navigation avancée de suivi de terrain',
       'rd.product.cruiseMissile.features.2': 'Capacité d\'engagement multi-cibles',
       'rd.product.cruiseMissile.features.3': 'Re-tâche de mission en temps réel',
       'rd.product.cruiseMissile.features.4': 'Fonctionnalités de survie améliorées',
       
       // Weapons & Ammunition Page
       'weapons.page.title': 'ARMES & MUNITIONS',
       'weapons.page.subtitle': 'Systèmes de défense avancés et munitions de précision',
       'weapons.sections.weapons.title': 'ARMES',
       'weapons.sections.ammunition.title': 'MUNITIONS',
       'weapons.browse.title': 'Parcourir par Catégorie',
       'weapons.noWeapons': 'AUCUNE ARME TROUVÉE',
       'weapons.noAmmunition': 'AUCUNE MUNITION TROUVÉE',
       'weapons.loading': 'Chargement des produits...',
       'weapons.error': 'Erreur de chargement des produits',
       'weapons.refresh': '🔄 Actualiser les Données',
       'weapons.refreshing': 'Actualisation...',
       'weapons.modal.close': 'Fermer',
       'weapons.modal.specs': 'Spécifications',
       
       // Weapons & Ammunition Technology Section
       'weapons.technology.title': 'TECHNOLOGIE AVANCÉE',
       'weapons.technology.subtitle': 'Nos produits intègrent une technologie de pointe développée grâce à des décennies de recherche et d\'application réelle.',
       'weapons.technology.ai.title': 'INTÉGRATION IA',
       'weapons.technology.ai.description': 'Algorithmes d\'apprentissage automatique pour la maintenance prédictive et la détection intelligente des menaces.',
       'weapons.technology.cybersecurity.title': 'CYBERSÉCURITÉ',
       'weapons.technology.cybersecurity.description': 'Chiffrement de qualité militaire et protocoles de communication sécurisés pour tous les systèmes.',
       'weapons.technology.performance.title': 'PERFORMANCE',
       'weapons.technology.performance.description': 'Optimisé pour une efficacité et une fiabilité maximales dans des conditions extrêmes.',
       
       // Weapons & Ammunition CTA Section
       'weapons.cta.title': 'BESOIN DE SOLUTIONS PERSONNALISÉES ?',
       'weapons.cta.subtitle': 'Notre équipe d\'ingénieurs se spécialise dans le développement de solutions adaptées aux exigences uniques.',
       'weapons.cta.button': 'Contacter Nos Ingénieurs',
       
       // Contact Page
       'contact.page.title': 'CONTACTEZ-NOUS',
       'contact.page.subtitle': 'Entrez en Contact',
       'contact.form.title': 'ENVOYER UN MESSAGE',
       'contact.form.name': 'Nom Complet',
       'contact.form.email': 'Adresse Email',
       'contact.form.message': 'Message',
       'contact.form.submit': 'Envoyer le Message',
       'contact.form.sending': 'Envoi...',
       'contact.form.success': 'Message envoyé avec succès !',
       'contact.form.error': 'Échec de l\'envoi du message. Veuillez réessayer ou nous contacter directement.',
       'contact.company.title': 'INFORMATIONS DE L\'ENTREPRISE',
       'contact.company.email.title': 'EMAIL',
       'contact.company.email.value': 'sales@centronaero.com',
       'contact.company.linkedin.title': 'LINKEDIN',
       'contact.company.linkedin.value': 'Centron Aerospace & Engineering'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n; 